import { getAccessToken } from "../storage/accessTokenStorage";
import { doRedirectFullUpdate } from "../../actions/thunks/schemaThunks";
import { schemaRequest } from "../../actions/schemaActions";

const redirectUpdate = (
  component,
  payload = null,
  message = null,
  submitEndpoint = null,
  redirectUrl = null
) => {
  component.props.dispatch(schemaRequest(component.props.id));
  const data = payload || component.props.data;
  const successMessage = message || "Updated Successfully!";
  const endpoint = submitEndpoint || component.props.submitEndpoint;
  const url = redirectUrl || component.props.deleteRedirectUrl;
  const accessToken = component.props.accessToken || getAccessToken();

  component.props.dispatch(
    doRedirectFullUpdate({
      accessToken,
      endpoint,
      successRedirectUrl: url,
      payload: data,
      navigate: component.props.navigate,
      message: successMessage,
      id: component.props.id,
    })
  );
};

export default redirectUpdate;
